module.exports = __webpack_public_path__ + "static/media/doubleLeaf.a9283637.svg";